import * as taskName from './task-name'
import { createValidationMessage } from '../../../../validation/create-validation-message'
import { selectIsTreatmentQuotationReadyForPurchase, selectTreatmentQuotation } from '../../../../treatment/state/quotation/selector'
import * as processUI from '../../process-ui'
import * as processAction from '../../process-action'
import { createUIDefinition } from '../default-task-definition'


export default createUIDefinition({
    taskName: taskName.CREATE_TREATMENT_QUOTATION,
    actionList: [
        {
            action: processAction.TREATMENT_QUOTATION,
            taskPath: ['objectDetail'],
        },
        {
            action: processAction.TREATMENT_PLAN,
            taskPath: ['objectDetail', 'customer', 'treatmentPlanList', 0],
        },
        {
            action: processAction.SALES_ORDER,
            taskPath: ['objectDetail'],
        },
    ],
    overwriteWidget: true,
    widgetList: [
        {
            component: processUI.OVERVIEW,
        },
        {
            component: processUI.SALES_ORDER_OVERVIEW_WIDGET,
        },
        {
            component: processUI.COMMENT_LIST,
        },
        {
            component: processUI.INITIAL_HESITATION_WIDGET_CONTAINER,
        },
        {
            component: processUI.TREATMENT_DURATION_WIDGET_CONTAINER,
            readOnly: true,
        },
        {
            component: processUI.SALES_NOTE_WIDGET_CONTAINER,
            readOnly: true,
        },
        {
            component: processUI.TREATMENT_QUOTATION_WIDGET,
        },
        {
            component: processUI.PRE_TREATMENT_REASON_WIDGET_CONTAINER,
            readOnly: true,
        },
        {
            component: processUI.PHYSICIAN_AND_SUPPLIER_WIDGET,
            readOnly: true,
        },
        {
            component: processUI.TREATMENT_PLAN_FILE_UPLOAD_WIDGET,
        },
        {
            component: processUI.ANAMNESIS_LIST_WIDGET_CONTAINER,
        },
        {
            component: processUI.STATE_TRANSITION_LOG_CONTAINER,
            readOnly: true,
            widgetProps: {

            },
        },
    ],
    taskValidatorSelector: [
        selectTreatmentQuotation,
        selectIsTreatmentQuotationReadyForPurchase,
    ],
    taskValidator: (task, processInstance, taskName, eventName, treatmentQuotation, readyForPurchase) => {
        if (eventName !== 'treatment_quotation_created') {
            return null
        }
        const messageList = []

        if (!treatmentQuotation) {
            messageList.push(createValidationMessage('No treatment quotation created', 'validateTreatmentQuotation.object'))
            return messageList
        }

        if (!readyForPurchase) {
            messageList.push(createValidationMessage('Treatment Quotation not valid', 'validateTreatmentQuotation.valid'))
        }

        return messageList
    },
})



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/set-and-shop-scan/create-treatment-quotation.js